import { createRoute, lazyRouteComponent, stripSearchParams } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { parsePlayerPosition, type PlayerPosition } from '../messages/index.ts'
import { rootRoute } from './root.tsx'

export interface RosterSearch {
  readonly q: string
  readonly position: PlayerPosition | null
}

/** No search, no filters — the state that stays out of the URL. */
const DEFAULT_ROSTER_SEARCH: RosterSearch = { q: '', position: null }

export const teamRosterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/teams/$teamId/roster',
  validateSearch: (search: Record<string, unknown>): RosterSearch => ({
    q: typeof search.q === 'string' ? search.q : '',
    position: parsePlayerPosition(search.position),
  }),
  search: {
    middlewares: [stripSearchParams(DEFAULT_ROSTER_SEARCH)],
  },
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club', 'coach'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/team-roster.tsx')),
})

export function teamRosterLink(teamId: number) {
  return {
    to: '/teams/$teamId/roster',
    params: { teamId: String(teamId) },
    search: DEFAULT_ROSTER_SEARCH,
  } as const
}
